module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_commonwealth-ff7fe9de5c0171d961c4f64e6dcd224c.png";